import React from 'react';
import {
  Dialog,
  Button,
} from '@chakra-ui/react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  closeOnOverlayClick?: boolean;
  closeOnEscape?: boolean;
  showCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  size = 'md',
  closeOnOverlayClick = true,
  closeOnEscape = true,
  showCloseButton = true,
}) => {
  return (
    <Dialog.Root 
      open={isOpen} 
      onOpenChange={({ open }) => !open && onClose()}
      closeOnInteractOutside={closeOnOverlayClick}
      closeOnEscape={closeOnEscape}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content maxW={getSizeValue(size)} position="relative">
          {showCloseButton && (
            <Dialog.CloseTrigger asChild>
              <Button 
                variant="ghost" 
                size="sm" 
                position="absolute" 
                top={2} 
                right={2}
                zIndex={1}
              >
                <X size={20} />
              </Button>
            </Dialog.CloseTrigger>
          )}
          {children}
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

// Helper function to convert size to actual values
const getSizeValue = (size: string) => {
  const sizeMap = {
    xs: '20rem',
    sm: '24rem', 
    md: '32rem',
    lg: '48rem',
    xl: '64rem',
    full: '100vw'
  };
  return sizeMap[size as keyof typeof sizeMap] || sizeMap.md;
};

// Export additional Dialog components for easy use
export const ModalHeader = Dialog.Header;
export const ModalTitle = Dialog.Title;
export const ModalBody = Dialog.Body;
export const ModalFooter = Dialog.Footer;
export const ModalCloseTrigger = Dialog.CloseTrigger;

export default Modal; 